import { I18n } from '@calendly/i18n'

// Maps a selected notification card key to the notification `kind`, the localized
// drawer description, and any event-type overrides the legacy section wrappers
// applied (calendar/email `notification_type`). Used by the CRUD notifications
// drawer to reuse the existing NotificationFields for content editing.
const COMMUNICATIONS = 'publisher.event_type_editor.sections.communications'

const SECTION_CONFIG = {
  calendar_invitation: {
    kind: 'invitee_invitation',
    notificationType: 'calendar',
    descriptionKey: `${COMMUNICATIONS}.invitation_confirmation.calendar_body`
  },
  email_confirmation: {
    kind: 'invitee_confirmation',
    notificationType: 'email',
    descriptionKey: `${COMMUNICATIONS}.invitation_confirmation.email_body`
  },
  email_cancellation: {
    kind: 'invitee_cancellation',
    notificationType: 'email',
    descriptionKey: `${COMMUNICATIONS}.invitation_cancellation.description`
  },
  email_reminders: {
    kind: 'invitee_reminder',
    descriptionKey: `${COMMUNICATIONS}.email_reminders.description`
  },
  text_reminders: {
    kind: 'invitee_sms_reminder',
    descriptionKey: `${COMMUNICATIONS}.text_reminders.description`
  },
  email_follow_up: {
    kind: 'invitee_email_follow_up',
    descriptionKey: `${COMMUNICATIONS}.email_reminders.description`
  }
}

export const getCrudNotificationSectionConfig = (sectionKey, eventType) => {
  const config = SECTION_CONFIG[sectionKey]
  if (!config) return null

  const drawerEventType = config.notificationType
    ? { ...eventType, notification_type: config.notificationType }
    : eventType

  return {
    kind: config.kind,
    drawerEventType,
    description: I18n.t(config.descriptionKey)
  }
}
